var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIInpatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.643 35.727c0-2.343 1.895-4.235 4.24-4.235 2.343 0 4.242 1.892 4.242 4.235 0 2.341-1.899 4.24-4.242 4.24-2.345 0-4.24-1.899-4.24-4.24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.597 33.133c1.865 0 3.371 1.462 3.387 3.313l0.007 8.944h-34.033v-12.248l30.639-0.009z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.039 45.383c1.151 0 2.086-0.935 2.086-2.086s-0.935-2.086-2.086-2.086h-6.030c-1.155 0-2.084 0.935-2.084 2.086 0 1.151 0.928 2.086 2.084 2.086h6.030z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.009 54.179v9.327h5.523v-29.578c0-1.522-1.23-2.759-2.755-2.759-1.53 0-2.768 1.237-2.768 2.759v13.575h-49.589v-19.155c0-1.523-1.328-2.762-2.855-2.762v0.002c-1.522 0-2.721 1.237-2.721 2.759v35.158h5.575v-9.327h49.59z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.508 0.14c1.767 0 4.661 0.743 6.271 2.505l-2.17 4.168c-0.948-1.226-2.432-2.014-4.101-2.014-1.649 0-3.116 0.77-4.065 1.973l-2.213-4.035c1.863-1.864 4.439-2.598 6.278-2.598zM38.883 4.34h1.238v-1.239h1.239v-1.236h-1.239v-1.238h-1.238v1.238h-1.237v1.236h1.237v1.239z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.482 10.248c0 2.199-1.783 3.982-3.982 3.982-2.2 0-3.981-1.783-3.981-3.982 0-2.201 1.782-3.983 3.981-3.983 2.199-0 3.982 1.782 3.982 3.983z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.67 15.365c-2.784 0.015-4.397 2.274-4.76 3.55l-3.392 11.133h3.433l2.5-8.542h1.779l-2.493 8.54h13.507l-2.475-8.54h1.778l2.566 8.542h3.382l-3.405-11.133c-0.362-1.26-1.941-3.476-4.664-3.544l-7.756-0.006z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.293 17.925c-4.888 0-8.86-3.974-8.86-8.862 0-4.889 3.971-8.864 8.86-8.864 4.886 0 8.864 3.976 8.864 8.864 0 4.888-3.979 8.862-8.864 8.862v0zM10.29 15.731c3.678 0 6.672-2.991 6.672-6.67 0-3.675-2.993-6.671-6.672-6.671-3.676 0-6.665 2.995-6.665 6.671-0 3.68 2.989 6.67 6.665 6.67v0z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.338 10.233c-0.198 0.091-0.442 0.082-0.639-0.048-0.166-0.107-0.268-0.275-0.296-0.46l-0.009-5.151c0-0.369 0.3-0.667 0.667-0.667 0.368 0 0.666 0.298 0.666 0.667v0 3.996l3.416-1.609c0.33-0.159 0.728-0.016 0.885 0.317v0c0.156 0.335 0.014 0.731-0.319 0.887v0l-4.372 2.067z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIInpatient);
export default __webpack_public_path__ + "static/media/i-inpatient.d0646c35.svg";
export { ForwardRef as ReactComponent };